"use client"

import { Component } from "react"
import { Mobile, PC, Tablet, Notebook } from "../../ReactiveMode"

class ChurchInformation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visionItems: [
        {
          icon: "fas fa-pray",
          title: "평신도 사역자 육성 및 지원",
          description:
              "교회의 모든 성도가 각자의 은사와 재능을 발견하고 개발하여 하나님 나라를 위해 사역할 수 있도록 지원합니다.",
        },
        {
          icon: "fas fa-users",
          title: "팀별 전문 목회사역 추진",
          description: "다양한 전문 분야별로 팀을 구성하여 효과적이고 전문적인 목회 사역을 추진합니다.",
        },
        {
          icon: "fas fa-church",
          title: "새성전 건축",
          description: "하나님께 드리는 예배와 다양한 사역을 위한 새로운 성전 건축을 추진합니다.",
        },
        {
          icon: "fas fa-hand-holding-usd",
          title: "장학기금 선교기금<br />복지기금 확보",
          description: "다음 세대 육성과 선교 사역, 그리고 어려운 이웃을 돕기 위한 기금을 마련합니다.",
        },
        {
          icon: "fas fa-user-graduate",
          title: "우리교회 다음세대를<br />세상 각 분야에서 리더로 육성",
          description: "교회의 다음 세대가 신앙 안에서 성장하여 사회 각 분야에서 리더십을 발휘할 수 있도록 양육합니다.",
        },
      ],
      ministryItems: [
        {
          icon: "fas fa-bullhorn",
          title: "전도 TYPE 사역",
          description: "다양한 전도 방법과 프로그램을 통해 복음을 전하고 영혼 구원에 힘씁니다.",
        },
        {
          icon: "fas fa-hands",
          title: "예배 MULTI 사역",
          description: "다양한 형태와 방식의 예배를 통해 모든 세대가 하나님께 영광을 돌리는 예배를 드립니다.",
        },
        {
          icon: "fas fa-user-friends",
          title: "제자삼는 사역",
          description: "성경적인 제자훈련을 통해 그리스도의 제자로 성장하고 또 다른 제자를 양육하는 사역을 추진합니다.",
        },
        {
          icon: "fas fa-user-tie",
          title: "평신도 리더 사역",
          description: "교회의 모든 성도가 각자의 자리에서 리더십을 발휘하여 하나님 나라를 확장하는 사역을 합니다.",
        },
        {
          icon: "fas fa-hands-helping",
          title: "돌봄 NETWORK 사역",
          description: "교회 내외의 어려운 이웃을 돌보고 섬기는 네트워크를 구축하여 그리스도의 사랑을 실천합니다.",
        },
      ],
    }
  }

  // 카드 렌더링 부분을 더 세련되게 수정합니다.
  // 비전 카드 렌더링 함수 수정
  renderVisionCard = (item, index) => {
    return (
        <div className="vision-card" key={index}>
          <div className="card-icon">
            <i className={item.icon}></i>
          </div>
          <div className="card-content">
            <h4 dangerouslySetInnerHTML={{__html: item.title}}></h4>
          </div>
        </div>
    )
  }

  // 사역 카드 렌더링 함수 수정
  renderMinistryCard = (item, index) => {
    return (
        <div className="ministry-card" key={index}>
          <div className="card-icon">
            <i className={item.icon}></i>
          </div>
          <div className="card-content">
            <h4 dangerouslySetInnerHTML={{__html: item.title}}></h4>
          </div>
        </div>
    )
  }

  renderHistoryItem = (item, index) => {
    return (
        <div className="timeline-item" key={index}>
          <div className="timeline-year">{item.year}</div>
          <div className="timeline-content">
            <h4 dangerouslySetInnerHTML={{__html: item.title}}></h4>
            <p>{item.description}</p>
          </div>
        </div>
    )
  }

  render() {
    const { visionItems, ministryItems, historyItems } = this.state
    const churchLogo = process.env.PUBLIC_URL + "/images/church-logo.png"
    const churchImage = process.env.PUBLIC_URL + "/images/church-intro.jpg"

    return (
        <section className="pf-page">
          <PC>
            <section className="church-info-content">
              <div className="background">
                <div className="layout">
                  {/* 교회 소개 - 환영 메시지 */}
                  <div className="church-welcome-clean">
                    <div className="welcome-card">
                      <div className="welcome-header">
                        <h1>할렐루야!</h1>
                      </div>
                      <div className="welcome-body">
                        <p className="welcome-main-text">
                          의정부 성실교회를 방문하신
                          <br />
                          여러분을 주님의 이름으로 환영합니다.
                        </p>
                        <div className="welcome-divider"></div>
                        <p className="welcome-sub-text">
                          의정부 성실교회는 대한예수교장로회(합신) 교단에 소속된 건전한 교회 입니다.</p>
                      </div>
                    </div>
                  </div>

                  {/* 5대 비전 */}
                  <div className="church-vision-section">
                    <h3 className="section-title">성실교회 5대 비전</h3>
                    <div className="vision-cards">
                      {visionItems.map((item, index) => (
                          <div className="vision-card" key={index}>
                            <div className="card-icon">
                              <i className={item.icon}></i>
                            </div>
                            <div className="card-content">
                              <h4 dangerouslySetInnerHTML={{ __html: item.title }}></h4>
                            </div>
                          </div>
                      ))}
                    </div>
                  </div>

                  {/* 5대 집중사역 */}
                  <div className="church-ministry-section">
                    <h3 className="section-title">성실교회 5대 집중사역</h3>
                    <div className="ministry-cards">
                      {ministryItems.map((item, index) => (
                          <div className="ministry-card" key={index}>
                            <div className="card-icon">
                              <i className={item.icon}></i>
                            </div>
                            <div className="card-content">
                              <h4 dangerouslySetInnerHTML={{ __html: item.title }}></h4>
                            </div>
                          </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </PC>

          <Notebook>
            <section className="church-info-content">
              <div className="background">
                <div className="layout">
                  {/* 교회 소개 - 환영 메시지 */}
                  <div className="church-welcome-clean">
                    <div className="welcome-card">
                      <div className="welcome-header">
                        <h1>할렐루야!</h1>
                      </div>
                      <div className="welcome-body">
                        <p className="welcome-main-text">
                          의정부 성실교회 홈페이지를 방문하신
                          <br />
                          여러분을 주님의 이름으로 환영합니다.
                        </p>
                        <div className="welcome-divider"></div>
                        <p className="welcome-sub-text">하나님의 사랑과 은혜가 함께하시길 기도합니다.</p>
                      </div>
                    </div>
                  </div>

                  {/* 5대 비전 */}
                  <div className="church-vision-section">
                    <h3 className="section-title">성실교회 5대 비전</h3>
                    <div className="vision-cards notebook-cards">
                      {visionItems.map((item, index) => (
                          <div className="vision-card" key={index}>
                            <div className="card-icon">
                              <i className={item.icon}></i>
                            </div>
                            <div className="card-content">
                              <h4 dangerouslySetInnerHTML={{ __html: item.title }}></h4>
                            </div>
                          </div>
                      ))}
                    </div>
                  </div>

                  {/* 5대 집중사역 */}
                  <div className="church-ministry-section">
                    <h3 className="section-title">성실교회 5대 집중사역</h3>
                    <div className="ministry-cards notebook-cards">
                      {ministryItems.map((item, index) => (
                          <div className="ministry-card" key={index}>
                            <div className="card-icon">
                              <i className={item.icon}></i>
                            </div>
                            <div className="card-content">
                              <h4 dangerouslySetInnerHTML={{ __html: item.title }}></h4>
                            </div>
                          </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Notebook>

          <Tablet>
            <section className="church-info-content">
              <div className="background">
                <div className="layout">
                  {/* 교회 소개 - 환영 메시지 */}
                  <div className="church-welcome-clean">
                    <div className="welcome-card">
                      <div className="welcome-header">
                        <h1>할렐루야!</h1>
                      </div>
                      <div className="welcome-body">
                        <p className="welcome-main-text">
                          의정부 성실교회 홈페이지를 방문하신
                          <br />
                          여러분을 주님의 이름으로 환영합니다.
                        </p>
                        <div className="welcome-divider"></div>
                        <p className="welcome-sub-text">하나님의 사랑과 은혜가 함께하시길 기도합니다.</p>
                      </div>
                    </div>
                  </div>

                  {/* 5대 비전 */}
                  <div className="church-vision-section">
                    <h3 className="section-title">성실교회 5대 비전</h3>
                    <div className="vision-cards tablet-cards">
                      {visionItems.map((item, index) => (
                          <div className="vision-card" key={index}>
                            <div className="card-icon">
                              <i className={item.icon}></i>
                            </div>
                            <div className="card-content">
                              <h4 dangerouslySetInnerHTML={{ __html: item.title }}></h4>
                            </div>
                          </div>
                      ))}
                    </div>
                  </div>

                  {/* 5대 집중사역 */}
                  <div className="church-ministry-section">
                    <h3 className="section-title">성실교회 5대 집중사역</h3>
                    <div className="ministry-cards tablet-cards">
                      {ministryItems.map((item, index) => (
                          <div className="ministry-card" key={index}>
                            <div className="card-icon">
                              <i className={item.icon}></i>
                            </div>
                            <div className="card-content">
                              <h4 dangerouslySetInnerHTML={{ __html: item.title }}></h4>
                            </div>
                          </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Tablet>

          <Mobile>
            <section className="church-info-content">
              <div className="background">
                <div className="layout">
                  {/* 교회 소개 - 환영 메시지 */}
                  <div className="church-welcome-clean">
                    <div className="welcome-card">
                      <div className="welcome-header">
                        <h1>할렐루야!</h1>
                      </div>
                      <div className="welcome-body">
                        <p className="welcome-main-text">
                          의정부 성실교회 홈페이지를 방문하신
                          <br />
                          여러분을 주님의 이름으로 환영합니다.
                        </p>
                        <div className="welcome-divider"></div>
                        <p className="welcome-sub-text">하나님의 사랑과 은혜가 함께하시길 기도합니다.</p>
                      </div>
                    </div>
                  </div>

                  {/* 5대 비전 */}
                  <div className="church-vision-section">
                    <h3 className="section-title">성실교회 5대 비전</h3>
                    <div className="vision-cards mobile-cards">
                      {visionItems.map((item, index) => (
                          <div className="vision-card" key={index}>
                            <div className="card-icon">
                              <i className={item.icon}></i>
                            </div>
                            <div className="card-content">
                              <h4 dangerouslySetInnerHTML={{ __html: item.title }}></h4>
                            </div>
                          </div>
                      ))}
                    </div>
                  </div>

                  {/* 5대 집중사역 */}
                  <div className="church-ministry-section">
                    <h3 className="section-title">성실교회 5대 집중사역</h3>
                    <div className="ministry-cards mobile-cards">
                      {ministryItems.map((item, index) => (
                          <div className="ministry-card" key={index}>
                            <div className="card-icon">
                              <i className={item.icon}></i>
                            </div>
                            <div className="card-content">
                              <h4 dangerouslySetInnerHTML={{ __html: item.title }}></h4>
6ㄴㅅ                            </div>
                          </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Mobile>
        </section>
    )
  }
}

export default ChurchInformation
